// imports
import CryptoJS from 'crypto-js';
import { Address } from 'abitype';
import localforage from 'localforage';
import { IWallet } from '../../common/types';

// interfaces / types / consts
const KEY_QUEST = 'new_quests';
const KEY_LOGIN_CYCLE = 'login_cycle';
const KEY_USER_WALLET = 'current_user_wallet';
const KEY_DELEGATE_WALLET = 'delegate_wallet';

// private methods
const encrypt = (message: string, key: string): string => CryptoJS.AES.encrypt(message, key).toString();
const decrypt = (cipher: string, key: string): string => CryptoJS.AES.decrypt(cipher, key).toString(CryptoJS.enc.Utf8);

// exports
export const setCurrentUserAddress = (address: Address): Promise<Address> => localforage.setItem(KEY_USER_WALLET, address);

export const setNotifyQuest = (address: Address, status: boolean): Promise<boolean> => {
  const key = `${address.toLowerCase()}_${KEY_QUEST}`;
  return localforage.setItem(key, status);
};

export const updateLoginCycle = (address: Address): Promise<number> => {
  const key = `${address.toLowerCase()}_${KEY_LOGIN_CYCLE}`;
  return localforage.getItem(key).then((pCycleCount) => {
    const cycleCount = (pCycleCount || 0) as number;
    return localforage.setItem(key, (cycleCount + 1) % 3);
  });
};

export const getDelegateWallet = (address: Address): Promise<IWallet | null> => {
  const key = `${address.toLowerCase()}_${KEY_DELEGATE_WALLET}`;
  return localforage.getItem(key)
    .then((wallet) => {
      const delegateWallet = wallet as IWallet | null;
      const { privateKey } = delegateWallet || { privateKey: '0x' };
      if (!privateKey.startsWith('0x')) { delegateWallet!.privateKey = decrypt(privateKey, address) as Address; }
      return Promise.resolve(delegateWallet);
    });
};

export const setDelegateWallet = (address: Address, delegateWallet: IWallet | null): Promise<IWallet | null> => {
  const key = `${address.toLowerCase()}_${KEY_DELEGATE_WALLET}`;
  const diskWallet = !delegateWallet ? null : { address: delegateWallet.address, privateKey: encrypt(delegateWallet.privateKey, address) };
  return localforage.setItem(key, diskWallet).then(() => delegateWallet);
};

export default {
  setNotifyQuest,
  updateLoginCycle,
  getDelegateWallet,
  setDelegateWallet,
  setCurrentUserAddress
};
